import './style.css';
import { defineComponent, computed, openBlock, createElementBlock, mergeProps, Fragment, renderList, unref, createElementVNode, toDisplayString, pushScopeId, popScopeId } from "vue";
var breadCrumb_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _withScopeId = (n) => (pushScopeId("data-v-daa8a222"), n = n(), popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "bread-icon" }, "/", -1));
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "bread-crumb",
  props: {
    list: { default: () => {
      return [];
    } },
    menuList: { default: () => {
      return [];
    } },
    parentKey: { default: () => {
      return [];
    } },
    showHome: { type: Boolean, default: true }
  },
  emits: ["link-click"],
  setup(__props, { emit }) {
    const props = __props;
    const breadList = computed(() => {
      let dataList = [];
      if (props.showHome) {
        dataList.push({ name: "\u9996\u9875", route: "/idx/home" });
      }
      if (props.parentKey.length) {
        let menuMap = fmtMenuList(props.menuList);
        let moduleArr = props.parentKey.filter((item) => menuMap[item]).map((item) => menuMap[item]);
        let moduleRoute = moduleArr.length && moduleArr[0] || {};
        if (moduleArr.length) {
          dataList.push({ name: moduleRoute.title, route: moduleRoute.route });
        }
      }
      return [...dataList, ...props.list];
    });
    function fmtMenuList(list, routeMap = {}) {
      list.forEach((item) => {
        const mKey = item.moduleKey;
        if (mKey && !routeMap[mKey]) {
          routeMap[mKey] = { title: item.title, route: item.route && item.route.path || item.path };
        }
        if (item.sub_navs && item.sub_navs.length) {
          fmtMenuList(item.sub_navs, routeMap);
        }
      });
      return routeMap;
    }
    function handleJump(item, index) {
      if (breadList.value && breadList.value.length && index !== breadList.value.length - 1) {
        emit("link-click", item.route);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "bread-header-wrap" }, _ctx.$attrs), [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(breadList), (item, index) => {
          return openBlock(), createElementBlock("span", {
            key: index,
            class: "bread-header-item"
          }, [
            createElementVNode("span", {
              class: "name",
              onClick: ($event) => handleJump(item, index)
            }, toDisplayString(item.name), 9, _hoisted_1),
            _hoisted_2
          ]);
        }), 128))
      ], 16);
    };
  }
});
var breadCrumb = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-daa8a222"]]);
export { breadCrumb as BreadCrumb };
